var components
try {
  components = {
    uIcon: function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u-icon/u-icon" */ "uview-ui/components/u-icon/u-icon.vue"
      )
    },
    uDatetimePicker: function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u-datetime-picker/u-datetime-picker" */ "uview-ui/components/u-datetime-picker/u-datetime-picker.vue"
      )
    },
    uPopup: function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u-popup/u-popup" */ "uview-ui/components/u-popup/u-popup.vue"
      )
    },
    uActionSheet: function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u-action-sheet/u-action-sheet" */ "uview-ui/components/u-action-sheet/u-action-sheet.vue"
      )
    },
  }
} catch (e) {
  if (
    e.message.indexOf("Cannot find module") !== -1 &&
    e.message.indexOf(".vue") !== -1
  ) {
    console.error(e.message)
    console.error("1. 排查组件名称拼写是否正确")
    console.error(
      "2. 排查组件是否符合 easycom 规范，文档：https://uniapp.dcloud.net.cn/collocation/pages?id=easycom"
    )
    console.error(
      "3. 若组件不符合 easycom 规范，需手动引入，并在 components 中注册该组件"
    )
  } else {
    throw e
  }
}
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  if (!_vm._isMounted) {
    _vm.e0 = function ($event) {
      _vm.showArriveTimePicker = true
    }
    _vm.e1 = function ($event) {
      _vm.showPickupTimePicker = true
    }
    _vm.e2 = function ($event) {
      _vm.showArriveTimePicker = false
    }
    _vm.e3 = function ($event) {
      _vm.showArriveTimePicker = false
    }
    _vm.e4 = function ($event) {
      _vm.showPickupTimePicker = false
    }
    _vm.e5 = function ($event) {
      _vm.showPickupTimePicker = false
    }
    _vm.e6 = function ($event) {
      _vm.showGoodsPopup = true
    }
    _vm.e7 = function ($event, item) {
      var _temp = arguments[arguments.length - 1].currentTarget.dataset,
        _temp2 = _temp.eventParams || _temp["event-params"],
        item = _temp2.item
      var _temp, _temp2
      _vm.isUrgent = item.id
    }
    _vm.e8 = function ($event) {
      _vm.showStorePopup = false
    }
    _vm.e9 = function ($event) {
      _vm.showStorePopup = false
    }
    _vm.e10 = function ($event, index) {
      var _temp3 = arguments[arguments.length - 1].currentTarget.dataset,
        _temp4 = _temp3.eventParams || _temp3["event-params"],
        index = _temp4.index
      var _temp3, _temp4
      _vm.storeList.forEach(function (row, i) {
        return (row.active = index === i)
      })
    }
    _vm.e11 = function ($event) {
      _vm.showGoodsPopup = false
    }
    _vm.e12 = function ($event) {
      _vm.showGoodsPopup = false
    }
    _vm.e13 = function ($event, index) {
      var _temp5 = arguments[arguments.length - 1].currentTarget.dataset,
        _temp6 = _temp5.eventParams || _temp5["event-params"],
        index = _temp6.index
      var _temp5, _temp6
      _vm.goodsOptions.forEach(function (row, i) {
        return (row.active = i === index)
      })
    }
    _vm.e14 = function ($event) {
      _vm.showAmountPopup = false
    }
    _vm.e15 = function ($event) {
      _vm.showAmountPopup = false
    }
    _vm.e16 = function ($event) {
      _vm.showAmountPopup = false
    }
    _vm.e17 = function ($event) {
      _vm.showReceiveAddress = false
    }
  }
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }